async function downloadProductImages() {
    const imgElements = document.querySelectorAll('.gallery__inner img, .owl-stage img');
    const downloadedNames = new Set();

    for (const img of imgElements) {
        let originalSrc = img.getAttribute('src') || img.getAttribute('data-src') || null;
        const srcset = img.getAttribute('data-srcset');

        if (!originalSrc && srcset) {
            const srcsetArray = srcset
                .split(',')
                .map(entry => entry.trim().split(' '))
                .filter(pair => pair.length === 2 && !isNaN(parseInt(pair[1], 10)))
                .map(([url, size]) => ({ url, width: parseInt(size, 10) }));

            const highestRes = srcsetArray.sort((a, b) => b.width - a.width)[0];
            originalSrc = highestRes?.url;
        }

        if (!originalSrc) continue;

        if (!originalSrc.startsWith('http')) {
            originalSrc = 'https:' + originalSrc;
        }

        const cleanUrl = originalSrc.split('?')[0];
        const parts = cleanUrl.split('/');
        let filename = parts.pop();

        // Limpiar sufijos como _2048x, _{width}x y UUIDs
        filename = filename
            .replace(/_\d+x|\_\{width\}x/, '')
            .replace(/_[a-f0-9\-]{36}(?=\.\w{3,4}$)/i, '');

        const filenameWithoutExtension = filename.split('.')[0];
        const extension = filename.split('.').pop().toLowerCase();
        const fullName = filename.toLowerCase(); // incluye extensión

        if (downloadedNames.has(fullName)) continue;
        downloadedNames.add(fullName);

        try {
            const response = await fetch(cleanUrl);
            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobURL;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Si es PNG, convertir y descargar como JPG también
            if (extension === 'png') {
                const formData = new FormData();
                formData.append('file', blob, filename);

                const responseJPG = await fetch('https://pngajpgfondoblanco.fly.dev/convert-to-jpg', {
                    method: 'POST',
                    body: formData
                });

                if (!responseJPG.ok) throw new Error('Backend conversion failed');

                const jpgBlob = await responseJPG.blob();
                const jpgBlobURL = URL.createObjectURL(jpgBlob);
                const jpgFilename = filenameWithoutExtension + '.jpg';

                // Añadir .jpg al set para evitar duplicados
                downloadedNames.add(jpgFilename.toLowerCase());

                const jpgLink = document.createElement('a');
                jpgLink.href = jpgBlobURL;
                jpgLink.download = jpgFilename;
                document.body.appendChild(jpgLink);
                jpgLink.click();
                document.body.removeChild(jpgLink);
            }

        } catch (error) {
            console.error(`Error downloading ${filename}:`, error);
        }
    }
}
